export default async function(brand = '') {
    const googleClass = await GoogleMapsLoader.getMap();
    if (brand == 'vauxhall') {
        return {
            path: 'M256 0C153.8 0 70.6 83.2 70.6 185.4c0 126.9 165.9 313.2 173 321 6.6 7.4 18.2 7.4 24.8 0 7.1-7.9 173-194.1 173-321C441.4 83.2 358.2 0 256 0zM256 278.7c-51.4 0-93.3-41.9-93.3-93.3S204.6 92.1 256 92.1s93.3 41.9 93.3 93.3S307.4 278.7 256 278.7z',
            fillColor: '#c90c0f',
            fillOpacity: 1,
            strokeColor: '#000000',
            strokeOpacity: 0.5,
            strokeWeight: 0.4,
            scale: 0.08,
            anchor: new googleClass.maps.Point(256, 512),
        };
    }
    if (brand == 'ds') {
        return '/img/ds/icons/map-pin.png';
    }
    return {
        path: 'M256 0C153.8 0 70.6 83.2 70.6 185.4c0 126.9 165.9 313.2 173 321 6.6 7.4 18.2 7.4 24.8 0 7.1-7.9 173-194.1 173-321C441.4 83.2 358.2 0 256 0zM256 278.7c-51.4 0-93.3-41.9-93.3-93.3S204.6 92.1 256 92.1s93.3 41.9 93.3 93.3S307.4 278.7 256 278.7z',
        fillColor: '#ffa100',
        fillOpacity: 1,
        strokeColor: '#000000',
        strokeOpacity: 0.5,
        strokeWeight: 0.4,
        scale: 0.08,
        anchor: new googleClass.maps.Point(256, 512),
    };
}


// WEBPACK FOOTER //
// ./resources/assets/js/modules/mapIcon.js